import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const API_URL = "https://api.lii.com.co:5101";

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please fill in both fields.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email, password }),
        credentials: "include"
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Invalid credentials.");
      }

      // ✅ Store `_id`, firstName, and lastName for ChatWindow
      const { _id, firstName, lastName, familyId } = data.user;
const token = data.token;  // 🔥 Récupération du token

// ✅ Stocker le token et les infos utilisateur
localStorage.setItem("user", JSON.stringify({ _id, firstName, lastName, familyId }));
localStorage.setItem("token", token);  // 🔥 Stockage du token

      navigate("/dashboard");
    } catch (error) {
      console.error("Login error:", error.message);
      setErrorMessage(error.message || "An error occurred during login.");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="w-full max-w-sm bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-3xl font-bold text-center text-green-600 mb-6">Se connecter</h2>

        {errorMessage && (
          <p className="text-red-500 text-center mb-4">{errorMessage}</p>
        )}

        <div className="mb-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="Email"
          />
        </div>

        <div className="mb-6">
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="Mot de passe"
          />
        </div>

        <button
          onClick={handleLogin}
          className="w-full bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition duration-300"
        >
          Se connecter
        </button>

        <div className="mt-4 text-center">
          <p className="text-sm text-gray-600">
           Vous n'avez pas encore de compte ?{' '}
            <a href="/signup" className="text-blue-600 hover:underline">S'inscrire</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
